import React, { Fragment } from 'react';
// Import images associated with content chunks
// images for siteContent[0]
import cont1Img1 from '../assets/images/majors-student-professor-university-of-arizona.jpg';
import cont1Img2 from '../assets/images/majors-oculus-university-of-arizona.jpg';
import cont1Img3 from '../assets/images/majors-students-biology-university-of-arizona.jpg';
import cont1Quote from '../assets/images/majors-student-university-of-arizona.png';
// images for siteContent[1]
import cont2Img1 from '../assets/images/majors-classroom-university-of-arizona.jpg';
import cont2Img2 from '../assets/images/majors-students-university-of-arizona.jpg';
import cont2Img3 from '../assets/images/majors-students-tucson.jpg';
import cont2Quote from '../assets/images/majors-student-tucson.png';
// images for siteContent[2]
import cont3Img1 from '../assets/images/majors-students-clubs.jpg';
import cont3Img2 from '../assets/images/majors-students-class.jpg';
import cont3Img3 from '../assets/images/majors-students-engineering.jpg';
import cont3Quote from '../assets/images/majors-student-law.png';

const style1 = {
	padding: '56.25% 0 0 0',
	position: 'relative'
};

const style2 = {
	height: '100%',
	left: '0',
	position: 'absolute',
	top: '0',
	width: '100%'
};

const siteContent = [
	{
		id: 1,
		align: 'left',
		textCont: {
			title: (
				<Fragment>
					PURSUE YOUR
					<br />
					PASSIONS
				</Fragment>
			),
			text: (
				<Fragment>
					<p>
					With 150+ majors available, including four pre-business options, as well as the only B.A. in Law degree program in the United States, you can mix and match according to your needs.{' '}
						<a href="https://www.arizona.edu/degree-search/majors" id="majors-list-text-link" target="_blank" rel="noopener">
							Browse a list of all undergraduate majors
						</a>{' '}
						and go for your goals. Once you’re on campus, add to your major with multiple minors or additional majors.
					</p>
					<br />
					<p>With a student-faculty ratio of 15:1, you’re set up for success. Small classroom settings and opportunities for one-on-one conversations with professors help you reach your goals.</p>
					<div class="video_responsive_padding" style={style1}>
						<div class="video_responsive_wrapper" style={style2}>
							<iframe title="Jessy majors and degrees Video" src="https://player.vimeo.com/video/675676081?h=84261ff237&title=false&portrait=false&byline=false" allowtransparency="true" frameborder="0" scrolling="no"  allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen width="100%" height="100%"></iframe>
						</div>
					</div>
				</Fragment>
			)
		},
		quoteCont: {
			quote: '“I felt like it was really important to choose a major that I felt passionate about. Growing up, my brother had leukemia. I decided I would dedicate my life to researching cures for diseases.”',
			quoteAuth: '— JESSY',
			quoteMajor: 'Biochemistry, Molecular & Cellular Biology, and Spanish & Portuguese',
			quoteImg: cont1Quote,
			quoteAlt: 'University of Arizona female biochemistry major student smiling with blue sky background.'
		},
		imageCont: [
			{
				id: 1,
				imgFile: cont1Img1,
				imgAlt: 'Male teacher identifying insects with student at the University of Arizona lab.'
			},
			{
				id: 2,
				imgFile: cont1Img2,
				imgAlt: 'Male student navigating a virtual reality headset in front of green screen at the University of Arizona.'
			},
			{
				id: 3,
				imgFile: cont1Img3,
				imgAlt: 'Female biology major students in class at the University of Arizona.'
			}
		],
		imageContMobile: [
			{
				id: 1,
				imgFile: cont1Img1,
				imgAlt: 'Male teacher identifying insects with student at the University of Arizona lab.'
			},
			{
				id: 2,
				imgFile: cont1Img2,
				imgAlt: 'Male student navigating a virtual reality headset in front of green screen at the University of Arizona.'
			}
		]
	},
	{
		id: 2,
		align: 'right',
		textCont: {
			title: (
				<Fragment>
					FIND
					<br />
					YOUR FIT
				</Fragment>
			),
			text: (
				<Fragment>
					<p>At the University of Arizona, you’ll get an exceptional education in the classroom and out. This is your chance to pursue a lifelong passion, try something new and pick up plenty of career experience along the way.</p>
					<br />
					<p>You’ll have the option to build an experience that could include double majors, minors and more. And if you’re unsure about what to major in, your academic advisor will help you explore your interests until you find what feels right. Additional support is available from the Advising Resource Center, which helps students from their first year to graduation – whether they’re undeclared or looking to make a change.</p>
				</Fragment>
			)
		},
		quoteCont: {
			quote: '“I switched majors... twice. Don’t worry if you’re not sure about what you want to do. There are plenty of resources on campus to help you find your path.”',
			quoteAuth: '— WILLIAM',
			quoteMajor: 'Law and Criminal Justice Studies',
			quoteImg: cont2Quote,
			quoteAlt: 'University of Arizona law student wearing glasses.'
		},
		imageCont: [
			{
				id: 1,
				imgFile: cont2Img1,
				imgAlt: 'Biology major students in classroom setting at the University of Arizona.'
			},
			{
				id: 2,
				imgFile: cont2Img2,
				imgAlt: 'Male students architecture majors standing in classroom with hexagons in the background.'
			},
			{
				id: 3,
				imgFile: cont2Img3,
				imgAlt: 'Students talking in front of window with blue sunny skies in Tucson, Arizona.'
			}
		],
		imageContMobile: [
			{
				id: 1,
				imgFile: cont2Img1,
				imgAlt: 'Biology major students in classroom setting at the University of Arizona.'
			},
			{
				id: 2,
				imgFile: cont2Img2,
				imgAlt: 'Male students architecture majors standing in classroom with hexagons in the background.'
			}
		]
	},
	{
		id: 3,
		align: 'left',
		textCont: {
			title: <Fragment>REST ASSURED</Fragment>,
			text: (
				<Fragment>
					<p>There is no one-size-fits-all Arizona student – discover the possibilities as you find your place at the University of Arizona. Internships, study abroad, research projects, volunteering and countless other opportunities elevate your potential and make an impact.</p>
					<br />
					<p>Join clubs (there are more than 600 to choose from), attend seminars and explore your interests. Your journey will be as unique as you are – break the mold and break out.</p>
				</Fragment>
			)
		},
		quoteCont: {
			quote: '“College isn’t about being perfect. Don’t be afraid to try something you never thought you would have. As long as you are enjoying yourself and learning in the process, everything will turn out how it’s supposed to.”',
			quoteAuth: '— LORENZO',
			quoteMajor: 'Philosophy, Politics, Economics and Law',
			quoteImg: cont3Quote,
			quoteAlt: 'University of Arizona student profile majoring in law.'
		},
		imageCont: [
			{
				id: 1,
				imgFile: cont3Img1,
				imgAlt: 'Students at the University of Arizona in a club meeting.'
			},
			{
				id: 2,
				imgFile: cont3Img2,
				imgAlt: 'University of Arizona students collaborating on a class project.'
			},
			{
				id: 3,
				imgFile: cont3Img3,
				imgAlt: 'Engineering majors working together at the University of Arizona.'
			}
		],
		imageContMobile: [
			{
				id: 1,
				imgFile: cont3Img1,
				imgAlt: 'Students at the University of Arizona in a club meeting.'
			},
			{
				id: 2,
				imgFile: cont3Img3,
				imgAlt: 'Engineering majors working together at the University of Arizona.'
			}
		]
	}
];

export default siteContent;
